import { Typography } from '@eventbrite/marmalade';
import { logEvent } from '@eventbrite/statsig';
import classNames from 'classnames';
import React from 'react';
import {
    LISTING_HEAP_IDS,
    STATSIG_EVENT_NAMES,
} from '../../../../../constants';
import styles from './DateCard.module.scss';
import { SliderCard } from './SliderCard';

interface Props {
    url: string;
    datesToDisplay: {
        day: string;
        fullDate: string;
        month: string;
        monthAbbr: string;
        time: string;
        weekDay: string;
        weekDayAbbr: string;
        year: string;
    };
    selected: boolean;
}

export const DateCard: React.FC<Props> = ({
    selected,
    url,
    datesToDisplay,
}) => {
    const {
        day,
        fullDate,
        month,
        monthAbbr,
        time,
        weekDay,
        weekDayAbbr,
        year,
    } = datesToDisplay;

    const formattedMonth =
        new Date().getFullYear().toString() === year
            ? month
            : `${monthAbbr} ${year}`;

    const formattedWeekDay = weekDay.length <= 9 ? weekDay : weekDayAbbr;

    return (
        <SliderCard selected={selected}>
            <a
                aria-label={fullDate}
                aria-current={selected ? 'date' : false}
                href={url}
                className={styles.root}
                data-heap-id={LISTING_HEAP_IDS.CAROUSEL_CARD}
                onClick={() => {
                    logEvent(STATSIG_EVENT_NAMES.CAROUSEL_CARD);
                }}
            >
                <time dateTime={fullDate}>
                    <div
                        className={`${styles.dateCardSection} ${styles.weekDay}`}
                    >
                        <Typography
                            as="span"
                            color="neutral-900"
                            variant="body-md-bold"
                        >
                            {formattedWeekDay}{' '}
                        </Typography>
                    </div>
                    <hr className={styles.divider} />
                    <div className={styles.dateCardSection}>
                        <Typography
                            as="span"
                            color="neutral-700"
                            variant="body-md"
                        >
                            {formattedMonth}{' '}
                        </Typography>
                    </div>
                    <div className={styles.dateCardSection}>
                        <div
                            className={classNames(styles.day, {
                                [styles.daySelected]: selected,
                            })}
                        >
                            <Typography
                                as="span"
                                color={selected ? 'white' : 'neutral-800'}
                                variant="body-lg"
                            >
                                {day}{' '}
                            </Typography>
                        </div>
                    </div>
                    <div className={styles.dateCardSection}>
                        <div>
                            <Typography
                                as="span"
                                color="neutral-700"
                                variant="body-md"
                            >
                                {time}
                            </Typography>
                        </div>
                    </div>
                </time>
            </a>
        </SliderCard>
    );
};
